import React from "react";
import { Link } from "react-router-dom";

const PrimaryButton = ({ text, btnStyle, icon, url, onclick }) => {
  return (
    <>
      {url ? (
        <Link
          to={`${url}`}
          className={`common_btn ${btnStyle} text-decoration-none text-center`}
        >
          {text} {icon ? icon : ""}
        </Link>
      ) : (
        <button
          className={`common_btn d-flex align-items-center justify-content-center ${btnStyle}`}
          onClick={onclick}
        >
          {text}{" "}
          {icon ? <span className="ms-2 d-inline-block ">{icon}</span> : ""}
        </button>
      )}
    </>
  );
};

export default PrimaryButton;